function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5DC6F6",
  fillRule: "nonzero",
  d: "M9.094 0H.634A.634.634 0 0 0 0 .634v12.69a.634.634 0 0 0 1.03.495l3.834-3.067 3.833 3.067a.634.634 0 0 0 1.031-.496V.634A.634.634 0 0 0 9.094 0zm-.635 12.003L5.26 9.444a.633.633 0 0 0-.792 0l-3.2 2.56V1.268H8.46v10.734z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-bookmark.01e7b1f1.svg";
export { SvgComponent as ReactComponent };